/**
 * Game Constants
 *
 * All magic numbers and configuration values in one place
 */

// Grid dimensions
export const COLUMNS = 4;
export const ROWS = 6;

// Credit system
export const INITIAL_CREDITS = 10;
export const HINT_COST = 1;
export const INCORRECT_GUESS_COST = 2;          // 1st wrong guess on a column
export const SECOND_INCORRECT_GUESS_COST = 3;   // 2nd wrong guess on a column
export const MAX_GUESSES_PER_COLUMN = 2;        // max attempts before forced reveal

// Scoring
export const CORRECT_MAIN_ANSWER_POINTS = 10;
export const POINTS_PER_UNUSED_CREDIT = 1;
export const MAX_POSSIBLE_SCORE = CORRECT_MAIN_ANSWER_POINTS + INITIAL_CREDITS;

// Input validation
export const MAX_INPUT_LENGTH = 80;

// LocalStorage keys
export const STORAGE_KEY_PREFIX = 'this-and-that-game';
export const STORAGE_LOG_PREFIX = 'this-and-that-log';
export const STORAGE_VERSION = '1.0';

// Puzzle file paths
export const PUZZLE_PATH_PREFIX = '/puzzles';
export const FALLBACK_PUZZLE_PATH = '/PuzzleDef-KFC.txt';

// Board dimensions (px)
export const BOARD_WIDTH = 1000;
export const BOARD_HEIGHT = 1000;
export const MIN_SCALE = 0.28;
export const MAX_SCALE = 1.0;

// Color values (from specs)
export const COLORS = {
  // Clue backgrounds
  light: '#f7e5c5',
  dark: '#262626',

  // Buttons
  hintButtonActive: '#d26e15',
  hintButtonDisabled: '#808080',
  guessButton: '#1f7d7e',

  // Feedback
  correct: '#387c47',
  incorrect: '#b64624',

  // Highlight — warm yellow for celebrations, active indicators, glows.
  // Yellower than theme cream (#f7e5c5) for visible contrast when adjacent.
  // Replaces previous #d4a843 (straw gold) and #d1930b (dark gold).
  highlight: '#e6b832',

  // Soft gold — lighter warm gold for paillette backgrounds (dialog, solution pill).
  // Sits between cream (#f7e5c5) and highlight (#e6b832) for a warm sparkly look
  // without the saturation of the highlight.
  softGold: '#d9a83b',
} as const;
